<template>
  <div class="flex flex-col p-[1rem] w-full">
    <div class="flex w-full p-[0.2rem] justify-between">
      <div class="flex flex-grow">
        <my-students-filter-summary :omit-attributes="['order.core.host_accepted_status']" />
      </div>
      <div class="w-full md:w-1/3 flex'">
        <my-students-search-dashboard />
      </div>
    </div>
    <results-wrapper>
      <div class="flex w-full">
        <current-attribute-display
          title="Current Stage Snapshot"
          attribute="student.status"
          :useTooltip="true"
          :attributeDescriptionFunction="getParticipantStatusDescription"
          :iconLookupFunction="getParticipantStatusIcon"
        />
      </div>
      <div class="flex w-full">
        <div
          class="grid grid-cols-1 gap-4 w-full"
          data-testid="dashboard-tables-container"
          :class="{ 'md:grid-cols-2': !hideSection }"
        >
          <div v-if="!hideSection">
            <filtered-results-list
              title="Students Who Need Acceptance"
              :includeCount="true"
              filterField="student.status"
              :filterValues="[StudentStatus.SUBMITTED.label, StudentStatus.CONFIRMED.label]"
              :limit="25"
              fieldLabel="Name"
              valueLabel="Action"
            />
          </div>
          <div :class="{ 'w-full': hideSection }">
            <current-attribute-display-list
              title="Top Programs"
              attribute="order.session.name"
              :limit="25"
              :class="{ 'w-full': hideSection }"
              fieldLabel="Name"
              valueLabel="# of Applications"
            />
          </div>
        </div>
      </div>
    </results-wrapper>
  </div>
</template>
<script setup>
import { computed } from "vue";
import CurrentAttributeDisplay from "./Display/CurrentAttributeDisplay.vue";
import CurrentAttributeDisplayList from "./Display/CurrentAttributeDisplayList.vue";
import FilteredResultsList from "./Display/FilteredResultsList.vue";
import ResultsWrapper from "./Display/ResultsWrapper.vue";
import MyStudentsFilterSummary from "./MyStudentsFilterSummary.vue";
import MyStudentsSearchDashboard from "./MyStudentsSearchDashboard.vue";

import { getParticipantStatusDescription, getParticipantStatusIcon, StudentStatus } from "./participantStatus";

const hideSection = computed(() => true); // As per AP-4261 we're just hiding this for now.
</script>
